import React, { useEffect, useState } from "react";
import "./Tag.css";
import type { ProjectType, TagSize } from "types";
import { useNavigate } from "react-router-dom";
import { codeTags, designTags, photoTags, TagType } from "consts";
import { titleCase } from "utilities";

interface Props {
  name: TagType;
  size?: TagSize;
}

export const Tag = ({ name, size = "small" }: Props) => {
  const [type, setType] = useState<ProjectType>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (designTags.includes(name)) {
      setType("design");
    } else if (codeTags.includes(name)) {
      setType("coding");
    } else if (photoTags.includes(name)) {
      setType("photography");
    }
  }, [name]);

  const handleClick = (e: React.SyntheticEvent) => {
    navigate(`/search?tag=${name}`);
  };

  return (
    <div
      className={`tag-${size} ${type && `tag-${type}`} clickable`}
      onClick={handleClick}
    >
      {size === "small" ? <h5>{name}</h5> : <h6>{titleCase(name)}</h6>}
    </div>
  );
};
